import uuid from 'uuid/v4';

const EIS_COOKIE_KEY = 'webauth';

/**
 * creates a cookie and sets it based on the name, value, and time in minutes.
 *
 * @export
 * @param {*} name - name of the cookie
 * @param {*} value - value of that cookie
 * @param {*} expiration - time before the cookie expires in minutes.
 */
export function setCookie(name, value, expiration) {
    var expires = "";
    
	if (expiration) {
		var date = new Date();
		date.setTime(date.getTime() + (expiration * 60000));
		expires = `expires=${date.toUTCString()}`;
	}
	document.cookie = `${name}=${(value || "")}; ${expires};`;
}

/**
 * returns the cookies values with the same name as what you pass in.
 *
 * @export
 * @param {*} key - name of the cookie
 * @returns returns a cookies values
 */
export function getCookie(key) {
	let name = key + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    
	for (let index = 0; index < cookies.length; index++) {
		let cookie = cookies[index].trim();
		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return "";
}





/**
 * EIS places a tracking cookie called webauth. This cookie has a value "un" that is used for the device_id in amplitude. 
 * This function simply creates a webauth cookie if one does not exist or If one does exist and doesn't contain a "un" value,
 * add the value equal to a new GUID. Expiration gets set to 24 hours.
 *
 * @export
 */
export function setWebAuthCookieIfNotExist() {
    const patt = new RegExp("un=.*?(?=&)");
	let webCookie = getCookie('webauth');
	
	if (webCookie != "") {
		const hasValue = patt.test(webCookie);
		if (!hasValue) {
			if (!webCookie.endsWith('&')) {
                webCookie = webCookie + '&';
			}
			setCookie(EIS_COOKIE_KEY, `${webCookie}un=${uuid()}&`, 1440);
		}
	} else {
		setCookie(EIS_COOKIE_KEY, `un=${uuid()}&`, 1440);
	}
}


// WEBPACK FOOTER //
// ./src/lib/CookieUtilities.js